import Logo from '@assets/svg/logo-footer.svg'
import { socialButtons } from '@config'
import { footerData } from '@slices/footer/footer-data'
import {
  ENHANCED_COMPONENT_ROLE,
  ENHANCED_COMPONENT_TYPE,
} from '@ui/enhanced-components/types'
import clsx from 'clsx/lite'
import { Link as GatsbyLink } from 'gatsby'
import React, { type FC } from 'react'

import { isHiddenClassname } from '../../../../plugins/gatsby-plugin-espace-client'

type FooterProps = {
  landing: boolean
  isDark?: boolean
}

const Footer: FC<FooterProps> = ({ landing, isDark = false }) => (
  <>
    <footer
      className={clsx(
        isHiddenClassname,
        isDark
          ? 'bg-amplification-background-black'
          : 'bg-amplification-black-premium',
        'border-t-[24px] border-solid border-t-amplification-iconic'
      )}
    >
      <div className="section-content-layout px-default pb-12 pt-5">
        {!landing && (
          <div className="grid grid-cols-4">
            {footerData.map(({ label, items }, i) => (
              <div
                key={i}
                className="col-span-4 tablet:col-span-2 laptop:col-span-1"
              >
                <h3 className="py-3 text-[#FFFFFF]">{label}</h3>
                {items.map(({ id, label, href, slug, icon: Icon }, i) => {
                  const isInternal = Boolean(slug)
                  const LinkComponent = isInternal
                    ? GatsbyLink
                    : href
                      ? 'a'
                      : 'button'
                  return (
                    <LinkComponent
                      key={i}
                      data-role={ENHANCED_COMPONENT_ROLE.MENU_ITEM}
                      data-type={ENHANCED_COMPONENT_TYPE.HYPERLINK}
                      href={href}
                      id={id}
                      target={isInternal ? '_self' : '_blank'}
                      to={slug}
                      className={clsx(
                        'flex items-center py-2 text-[#FFFFFF]/70',
                        Icon
                          ? 'mb-4 w-full items-center justify-center gap-1 rounded-full border-[1px] border-solid border-[#FFFFFF]/20 px-[14px] py-[15px] tablet:w-fit tablet:py-[6px]'
                          : 'w-fit hover:underline tablet:py-1'
                      )}
                    >
                      {Icon && <Icon fill="#FFFFFF" size={17} />}
                      {label}
                    </LinkComponent>
                  )
                })}
              </div>
            ))}
          </div>
        )}
        <div className="mt-8 flex flex-col gap-5 border-t-[1px] border-solid border-t-[#FFFFFF]/20 py-6 tablet:flex-row tablet:justify-between">
          <Logo className="w-52" />
          {!landing && (
            <div className="flex flex-row items-center gap-3">
              {socialButtons.map(({ icon: Icon, href }) => (
                <a
                  key={href}
                  className="flex items-center rounded-full border-[1px] border-solid border-[#FFFFFF]/20 p-3"
                  href={href}
                  rel="noreferrer"
                  target="_blank"
                >
                  <Icon fill="#FFFFFF" size={24} />
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </footer>
  </>
)

export default Footer
